import Vue from 'vue';
import Vuetify from 'vuetify';
import pl from 'vuetify/es5/locale/pl';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: 'mdi',
  lang: {
    locales: { pl },
    current: 'pl',
  },
});